import React from 'react';

const SuperAdminProfileSubscription = () => {
  return (
    <div className='flex w-full bg-gray-50 h-screen justify-center items-center'>
     <div className='text-4xl text-yellow-300'> SuperAdminProfileSubscription </div>
    </div>
  );
};

export default SuperAdminProfileSubscription;